module.exports = __webpack_public_path__ + "img/fi-organic-breakfast-600x395.d591c4d1.jpg";